import { trace } from 'owa-trace';
import {
    Category,
    UserDataCategoryResponse,
    UserDataItem,
    UserDataItemProperty,
    UserDataItemResponse,
    UserDataResponseStatus,
} from '../data/schema/UserDataStoreSchema';

const USER_DATA_NOT_FOUND_ERROR_CODE = 404;
const USER_DATA_INVALID_REQUEST_ERROR_CODE = 400;
const USER_DATA_KEY_CONFLICT_ERROR_CODE = 409;

/**
 * Process the UserDataItem mutate response from the server.
 */
export async function processItemMutateResponse(
    response: Response,
    actionName: string
): Promise<UserDataItemResponse> {
    if (response.ok) {
        const data = await response.json();
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.SUCCESS,
            userDataItem: resolveUserDataItem(data),
        });
    } else {
        return <UserDataItemResponse>{
            status: processFailedResponseStatus(response, actionName),
        };
    }
}

/**
 * Process the Category mutate response from the server.
 */
export async function processCategoryMutateResponse(
    response: Response,
    actionName: string
): Promise<UserDataCategoryResponse> {
    if (response.ok) {
        const data = await response.json();
        return Promise.resolve(<UserDataCategoryResponse>{
            status: UserDataResponseStatus.SUCCESS,
            category: resolveUserDataCategory(data),
        });
    } else {
        return <UserDataCategoryResponse>{
            status: processFailedResponseStatus(response, actionName),
        };
    }
}

/**
 * Process the mutate response status from the server.
 */
export function processFailedResponseStatus(
    response: Response,
    actionName: string
): UserDataResponseStatus {
    switch (response.status) {
        case USER_DATA_NOT_FOUND_ERROR_CODE:
            return UserDataResponseStatus.NOT_FOUND;
        case USER_DATA_INVALID_REQUEST_ERROR_CODE:
            return UserDataResponseStatus.INVALID_DATA;
        case USER_DATA_KEY_CONFLICT_ERROR_CODE:
            return UserDataResponseStatus.CONFLICT;
        default:
            logUserDataResponseError(actionName, 'Request failed with status ' + response.status);
            return UserDataResponseStatus.UNEXPECTED_ERROR;
    }
}

const resolveUserDataCategory = (data: any) =>
    <Category>{
        id: data.id,
        name: data.name,
    };

const resolveUserDataItem = (data: any) =>
    <UserDataItem>{
        id: data.id,
        categoryName: data.category,
        categoryId: data.categoryID,
        key: data.key,
        value: data.text,
        dataSource: data.dataSource,
        property: <UserDataItemProperty>{
            creationTimeUTC: data.createdDateTime,
            lastModifiedTimeUTC: data.lastModifiedDateTime,
            isPinned: data.anxillaryProperties['Pin'],
        },
    };

export function logUserDataResponseError(actionName: string, errorText: string) {
    trace.info(`Error: [${actionName}]. Response: ${errorText}`);
}
